<template>
  <div>
    <task-detail @onSave="taskCreated" />
    <policy-detail @onClosed="fetchDetail" />

    <div v-if="!hideGoBack" class="d-flex" style="margin-bottom: 1.70rem;" @click="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="38" viewBox="0 0 40 38" fill="none" style="cursor: pointer;">
        <path d="M38.75 19.0003H1.25M1.25 19.0003L18.9583 1.29199M1.25 19.0003L18.9583 36.7087" stroke="#FF7C48" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
      </svg>

      <div class="d-flex align-items-center" style="margin-left: 1.25rem; gap: 2.34rem;">
        <div>
          <h1 class="title">{{ $t("risk.organization") }}</h1>
        </div>
      </div>
    </div>

    <content-loading v-if="isLoading" />
    <div v-else>
      <b-card no-body class="custom-card shadow-none custom-accordion">
        <b-card-header header-tag="header" role="tab">
          <a v-b-toggle="'accordion_analysis'" class="text-dark" href="javascript: void(0);">
            <h5>
              {{ $t("risk.analysis") }}
            </h5>
          </a>
        </b-card-header>

        <b-collapse @show="isAccordionAnalysisOpen = true" @hidden="isAccordionAnalysisOpen = false" id="accordion_analysis" :visible="true" style="background-color: #F5F7F9;">
          <div v-if="isAccordionAnalysisOpen" class="d-flex flex-wrap mt-4 pl-4 pr-4 mb-4">
            <div class="d-flex flex-wrap flex-grow-0 flex-shrink-0" style="width: 100%; gap: 1rem;">
              <div class="r-select-container">
                <h6>{{ $t("risk.status.text") }}</h6>
                <select disabled class="form-control " v-model="form.status">
                  <option value="RATING">{{ $t("risk.status.rating") }}</option>
                  <option value="ACTIVE">{{ $t("risk.status.active") }}</option>
                  <option value="INACTIVE">{{ $t("risk.status.inactive") }}</option>
                </select>
              </div>
              <div class="r-select-container">
                <h6>{{ $t("risk.related-compliances") }}</h6>

                <input v-if="form.products && form.products.length > 0" disabled type="text" class="form-control" :value="form.products.join(',')" />
                <input v-else type="text" class="form-control" disabled />
              </div>

              <div class="w-50 ">
                <h6>{{ $t("file-manager.related-files") }}</h6>
                <i
                  v-if="form._id"
                  class="iconoir-page font-size-24 hand mt-1"
                  @click="redirectToRelatedFiles(form)"
                  v-on:click.stop
                  v-b-tooltip.hover
                  :title="$t('file-manager.view-related-files')"
                ></i>
              </div>

              <div class="r-select-container">
                <h6>{{ $t("risk.category.name") }}</h6>
                <select class="form-control " v-model="form.category">
                  <option value="ADMINISTRATIVE">{{ $t("risk.category.administrative") }}</option>
                  <option value="TECHNICAL">{{ $t("risk.category.technical") }}</option>
                  <option value="LEGAL">{{ $t("risk.category.legal") }}</option>
                </select>
              </div>

              <div class="r-select-container">
                <h6>{{ $t("risk.owner") }}</h6>
                <select @change="ownerChanded" class="form-control " v-model="form.owner">
                  <option :disabled="!hasRiskAdminPermission" value="ORGANIZATION">{{ $t("organization.text") }}</option>
                  <option value="DEPARTMENT">{{ $t("department.text") }}</option>
                  <option value="PROCESS">{{ $t("process.text") }}</option>
                </select>
              </div>

              <div v-if="form.owner" class="r-select-container">
                <div v-if="form.owner == 'ORGANIZATION'">
                  <h6>{{ $t("organization.text") }}</h6>
                  <filter-select
                    id="organizationFilter"
                    ref="organizationFilter"
                    disabled
                    :selected="currentOrganization"
                    :placeholder="$t('organization.text')"
                    :multiple="false"
                    @changed="onOrganizationSelect"
                  />
                </div>
                <div v-if="form.owner == 'DEPARTMENT'">
                  <h6>{{ $t("department.text") }}</h6>
                  <filter-select
                    id="departmentFilter"
                    ref="departmentFilter"
                    :selected="form.dataOwner.department"
                    :placeholder="$t('department.text')"
                    :multiple="false"
                    @filter="onDepartmentSearch"
                    @changed="onDepartmentSelect"
                  />
                </div>
                <div v-if="form.owner == 'PROCESS'">
                  <h6>{{ $t("process.text") }}</h6>
                  <filter-select
                    id="processFilter"
                    ref="processFilter"
                    :selected="form.dataOwner.process"
                    :placeholder="$t('process.text')"
                    :multiple="false"
                    @filter="onProcessSearch"
                    @changed="onProcessSelect"
                  />
                </div>
              </div>

              <div class="r-select-container">
                <h6>{{ $t("risk.admin") }}</h6>
                <organization-member-select :selected="form.admin" @onSelect="onMemberSelect" :organization="currentOrganization" :filterFunction="filterFunction" />
                <!-- <sweet-input class="d-block" :placeholder="$t('risk.admin')" v-model="form.admin" :isValid="!$v.form.admin.$error" /> -->
              </div>
              <div class="r-select-container"></div>

              <div class="r-select-container w-76">
                <h6>
                  {{ $t("risk.definition.text") }}
                  <!-- <i v-if="form._id" class="bx bx-search font-size-16 align-middle"></i> -->
                  <!-- <i v-else v-b-modal="'definition-modal-select'" class="bx bx-search font-size-16 align-middle"></i> -->
                </h6>

                <!-- <sweet-textarea
                  v-if="form._id && !form.originalId"
                  @blur="onDefinitionBlur"
                  :value="form.name"
                  :isValid="!$v.form.name.$error"
                  type="text"
                  layout="vertical"
                  :placeholder="$t('risk.definition.text')"
                  :rows="4"
                  disabled
                /> -->
                <sweet-textarea
                  @blur="onDefinitionBlur"
                  v-model="form.name"
                  :isValid="!$v.form.name.$error"
                  type="text"
                  layout="vertical"
                  :placeholder="$t('risk.definition.text')"
                  :rows="4"
                />
              </div>
              <div class="r-select-container"></div>

              <div class="w-28">
                <div class="d-flex flex-row">
                  <div>
                    <h6>{{ $t("risk.threat-definition.text") }}</h6>
                  </div>
                  <div>
                    <right-panel
                      class="float-left"
                      id="sidebar-threat-definition"
                      width="600px"
                      :icon="'mdi mdi-plus'"
                      :text="$t('risk.threat-definition.new')"
                      @hidden="rightPanelClosed"
                    >
                      <div class="pl-5 pr-5">
                        <OrganizationRiskThreatDefinitionForm @onSave="onThreatSaved" :hide-library="true" />
                      </div>
                    </right-panel>
                  </div>
                </div>

                <div class="p-2">
                  <filter-select
                    id="threatFilter"
                    ref="threatFilter"
                    :limit="3"
                    :placeholder="$t('risk.threat-definition.text')"
                    :multiple="true"
                    @filter="onThreatDefinitionSearch"
                    :selected="form.threats"
                    @changed="onThreatDefinitionSelect"
                  />
                </div>
              </div>
              <div class="w-28">
                <div class="d-flex flex-row">
                  <div>
                    <h6>{{ $t("risk.weakness-definition.text") }}</h6>
                  </div>
                  <div>
                    <right-panel
                      class="float-left"
                      id="sidebar-weakness-definition"
                      width="600px"
                      :icon="'mdi mdi-plus'"
                      :text="$t('risk.weakness-definition.new')"
                      @hidden="rightPanelClosed"
                    >
                      <div class="pl-5 pr-5">
                        <OrganizationRiskWeaknessDefinitionForm @onSave="onWeaknessSaved" :hide-library="true" />
                      </div>
                    </right-panel>
                  </div>
                </div>
                <div class="p-2">
                  <filter-select
                    id="weaknessFilter"
                    ref="weaknessFilter"
                    :limit="3"
                    :placeholder="$t('risk.weakness-definition.text')"
                    :multiple="true"
                    @filter="onWeaknessDefinitionSearch"
                    :selected="form.weaknesses"
                    @changed="onWeaknessDefinitionSelect"
                  />
                </div>
              </div>

              <div class="r-select-container">
                <h6>{{ $t("risk.source.text") }}</h6>
                <select class="form-control mt-3" v-model="form.source">
                  <option :value="undefined">{{ $t("risk.source.select") }}</option>
                  <option value="COMPELLING">{{ $t("risk.source.compelling") }}</option>
                  <option value="INTENTIONAL">{{ $t("risk.source.intentional") }}</option>
                  <option value="UNINTENTIONAL">{{ $t("risk.source.unintentional") }}</option>
                  <option value="INTENTIONAL_UNINTENTIONAL">{{ $t("risk.source.intentional-unintentional") }}</option>
                  <option value="INTENTIONAL_UNINTENTIONAL_COMPELLING">{{ $t("risk.source.intentional-unintentional-compelling") }}</option>
                </select>
              </div>
              <div class="r-select-container w-76">
                <h6>{{ $t("common.note") }}</h6>
                <textarea v-model="form.note" type="text" class="form-control" :placeholder="$t('common.note')" rows="4"></textarea>
              </div>

              <b-card v-if="showRelatedAssetGroup" no-body class="custom-card shadow-none custom-accordion w-100 ">
                <b-card-header header-tag="header" role="tab" class="w-100 bg-primary">
                  <a v-b-toggle="'accordion_asset_group'" class="text-dark" href="javascript: void(0);">
                    <h5 class="text-dark">
                      {{ $t("risk.related-asset-groups") }}
                    </h5>
                  </a>
                </b-card-header>
                <b-collapse id="accordion_asset_group" style="background-color: #F5F7F9;" :visible="true">
                  <div class="text-right">
                    <right-panel
                      class="float-right mt-2"
                      id="sidebar-new-asset-group"
                      width="850px"
                      :icon="'mdi mdi-plus'"
                      :text="$t('risk.add-asset-group')"
                      @hidden="rightPanelClosed"
                    >
                      <div class="pl-5 pr-5">
                        <RiskAssetGroupRelationForm
                          @saved="assetGroupRelationSaved"
                          @relationWithRiskCreated="handleRelationWithRiskCreated"
                          :risk="form"
                        ></RiskAssetGroupRelationForm>
                      </div>
                    </right-panel>
                  </div>

                  <div class="table-responsive pr-4 pt-2 ml-4">
                    <table class="table table-bordered table-striped" v-if="riskAssetGroupPagination && riskAssetGroupPagination.docs.length > 0">
                      <thead>
                        <tr>
                          <th>{{ $t("asset-group-category.text") }}</th>
                          <th>{{ $t("asset-group.name") }}</th>
                          <th>{{ $t("asset-group.degree-of-criticality") }}</th>
                          <th>{{ $t("risk.possibility") }} <i id="popover-possibility" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i></th>
                          <th>{{ $t("risk.effect") }} <i id="popover-effect" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i></th>
                          <th>{{ $t("risk.risk-point") }}</th>
                          <th>{{ $t("risk.degree.title") }}</th>
                          <th>{{ $t("common.description") }}</th>
                          <b-popover container="popover-info" custom-class="wide-popover" target="popover-possibility" triggers="hover focus" placement="right">
                            <!-- <template #title>İstatistikler</template> -->
                            <table class="table mb-0">
                              <thead>
                                <tr>
                                  <th>{{ $t("risk.possibility") }}</th>
                                  <th>{{ $t("risk.info.possibility.title") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="level in [1, 2, 3, 4, 5]" :key="`possibility-${level}`">
                                  <td>
                                    <p class="mb-1">{{ level }}-{{ $t(getAppliedRiskValueKey(level)) }}</p>
                                  </td>
                                  <td>
                                    <p v-for="(line, idx) in getPossibilityLines(level)" :key="`possibility-${level}-${idx}`" class="mb-1">{{ line }}</p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-popover>
                          <b-popover container="popover-info" custom-class="wide-popover" target="popover-effect" triggers="hover focus" placement="right">
                            <!-- <template #title>İstatistikler</template> -->
                            <table class="table mb-0">
                              <thead>
                                <tr>
                                  <th>{{ $t("risk.effect") }}</th>
                                  <th>{{ $t("risk.info.effect.title") }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="level in [1, 2, 3, 4, 5]" :key="`effect-${level}`">
                                  <td>
                                    <p class="mb-1">{{ level }}</p>
                                  </td>
                                  <td>
                                    <p class="mb-1">{{ $t(`risk.info.effect.${level}`) }}</p>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </b-popover>
                          <th></th>
                        </tr>
                      </thead>

                      <tr v-for="item in riskAssetGroupPagination.docs" :key="item._id" class="hider">
                        <td>
                          <span v-if="item.assetGroupCategory">{{ item.assetGroupCategory.name | translate }}</span>
                        </td>

                        <td>
                          <span v-if="item.assetGroup">{{ item.assetGroup.name | translate }}</span>
                        </td>

                        <td>
                          <span v-if="item.assetGroup">{{ item.assetGroup.criticalityLevel }}</span>
                        </td>
                        <td>
                          <span>{{ item.possibility }}</span>
                        </td>
                        <td>
                          <span>{{ item.effectValue }}</span>
                        </td>
                        <td>
                          <span>{{ item.riskPoint }}</span>
                        </td>
                        <td>
                          <div class="legend" style="display: inline!important;">
                            <div v-if="item.degree == 'PREVENT'" class="legend-item">
                              <span>{{ $t("risk.degree.prevent") }}</span>
                            </div>
                            <div v-if="item.degree == 'RECOMMEND_PREVENT'" class="legend-item">
                              <span>{{ $t("risk.degree.recommend-prevent") }}</span>
                            </div>
                            <div v-if="item.degree == 'ACCEPT'" class="legend-item">
                              <span>{{ $t("risk.degree.accept") }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <span>{{ item.description | translate }}</span>
                        </td>

                        <td>
                          <span v-b-tooltip.hover :title="$t('common.edit')" class="hand text-primary mr-1" @click="editAssetGroupRelation(item)">
                            <i class="bx bx-pencil align-middle"></i
                          ></span>
                        </td>
                        <td>
                          <span v-b-tooltip.hover :title="$t('common.edit')" class="hand text-danger mr-1" @click="removeRiskAssetGroupRelation(item._id)">
                            <i class="bx bx-trash align-middle"></i
                          ></span>
                        </td>
                      </tr>
                    </table>

                    <div class="text-center">
                      <empty v-if="!riskAssetGroupPagination || riskAssetGroupPagination.docs.length == 0">
                        <h5 class="text-center" id="myText">
                          {{ $t("asset-group.empty") }}
                        </h5>
                      </empty>
                    </div>
                    <div v-if="riskAssetGroupPagination" class="row">
                      <div class="col">
                        <ul class="pagination pagination-rounded mb-0">
                          <b-pagination
                            v-model="riskAssetGroupRequest.options.page"
                            :total-rows="riskAssetGroupPagination.totalDocs"
                            :per-page="riskAssetGroupPagination.limit"
                            limit="10"
                            size="sm"
                          ></b-pagination>
                        </ul>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </b-card>

              <div class="r-select-container w-76 mt-2 mb-4">
                <h6>{{ $t("risk.applied-control.plural") }} <i v-b-modal="'applied-control-modal-select'" class="font-size-16 align-middle"></i></h6>

                <div class="mb- d-flex justify-content-between">
                  <div class="flex-row">
                    <right-panel
                      class="float-left"
                      id="sidebar-applied-control"
                      width="600px"
                      :icon="'mdi mdi-plus'"
                      :text="$t('risk.applied-control.new')"
                      @hidden="rightPanelClosed"
                    >
                      <div class="pl-5 pr-5">
                        <OrganizationRiskAppliedControlForm :hide-library="true" @onSave="onAppliedControlSaved" />
                      </div>
                    </right-panel>
                  </div>
                  <div class="flex-row">
                    <risk-applied-control-recommendation @onApply="applyRecommendation" :riskDefinition="form.name"></risk-applied-control-recommendation>
                  </div>
                </div>

                <div class="p-2">
                  <filter-select
                    id="appliedControlFilter"
                    ref="appliedControlFilter"
                    :selected="form.appliedControl"
                    :placeholder="$t('risk.applied-control.plural')"
                    :multiple="true"
                    @filter="onAppliedControlSearch"
                    @changed="onAppliedControlSelect"
                  />
                </div>
              </div>
            </div>

            <div class="w-25">
              <div v-if="!isPossibilityDisabled">
                <h6>
                  {{ $t("risk.possibility") }}
                  <i id="popover-possibility" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
                </h6>

                <b-popover container="popover-info" custom-class="wide-popover" target="popover-possibility" triggers="hover focus" placement="right">
                  <!-- <template #title>İstatistikler</template> -->
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t("risk.possibility") }}</th>
                        <th>{{ $t("risk.info.possibility.title") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="level in [1, 2, 3, 4, 5]" :key="`possibility-${level}`">
                        <td>
                          <p class="mb-1">{{ level }}-{{ $t(getAppliedRiskValueKey(level)) }}</p>
                        </td>
                        <td>
                          <p v-for="(line, idx) in getPossibilityLines(level)" :key="`possibility-${level}-${idx}`" class="mb-1">{{ line }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-popover>

                <select class="form-control" :disabled="isPossibilityDisabled" v-model="form.possibility">
                  <option :value="1">1-{{ $t("risk.applied-risk-value.lowest") }} </option>
                  <option :value="2">2-{{ $t("risk.applied-risk-value.low") }}</option>
                  <option :value="3">3-{{ $t("risk.applied-risk-value.medium") }}</option>
                  <option :value="4">4-{{ $t("risk.applied-risk-value.high") }}</option>
                  <option :value="5">5-{{ $t("risk.applied-risk-value.highest") }}</option>
                </select>
              </div>
            </div>
            <div class="w-25 ml-4">
              <div v-if="!isPossibilityDisabled">
                <h6 style="display: inline-block;">
                  {{ $t("risk.effect") }}
                </h6>

                <i id="popover-effect" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
                <b-popover container="popover-info" custom-class="wide-popover" target="popover-effect" triggers="hover focus" placement="right">
                  <!-- <template #title>İstatistikler</template> -->
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>{{ $t("risk.effect") }}</th>
                        <th>{{ $t("risk.info.effect.title") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="level in [1, 2, 3, 4, 5]" :key="`effect-${level}`">
                        <td>
                          <p class="mb-1">{{ level }}</p>
                        </td>
                        <td>
                          <p class="mb-1">{{ $t(`risk.info.effect.${level}`) }}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </b-popover>

                <select class="form-control" :disabled="isPossibilityDisabled" v-model="form.effectValue">
                  <option :value="1">1</option>
                  <option :value="2">2</option>
                  <option :value="3">3</option>
                  <option :value="4">4</option>
                  <option :value="5">5</option>
                </select>
              </div>
            </div>
            <div class="w-25"></div>

            <div style="width: 52%;" class="mt-3">
              <sweet-button
                @click="handleCalculateButtonClicked()"
                buttonClass="mt-3"
                :disabled="!isCalculateButtonActive"
                :loading="isCalculating"
                variant="secondary"
                size="sm"
                :block="true"
                icon="fa fa-calculator"
              >
                <span v-html="$t('risk.calculate-risk-point')"></span>
              </sweet-button>
            </div>
            <div class="r-select-container"></div>
            <div class="r-select-container"></div>
            <div class="w-25">
              <h6 class="mt-2">
                {{ $t("risk.risk-point") }}
                <i id="popover-point" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
              </h6>

              <input disabled v-model="form.appliedRiskPoint" type="number" min="1" max="50" class="form-control" />
            </div>
            <b-popover container="popover-info" custom-class="wide-popover" target="popover-point" triggers="hover focus" placement="right">
              <!-- <template #title>İstatistikler</template> -->
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>{{ $t("risk.risk-point") }}</th>
                    <th>{{ $t("risk.info.point.title") }}</th>
                  </tr>
                </thead>
                <tbody v-if="riskRatingDefinition">
                  <tr>
                    <td class="bg-success">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.low") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.lowest.min }}-{{ riskRatingDefinition.low.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.1`) }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-light-warning">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.medium") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.medium.min }}-{{ riskRatingDefinition.medium.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.2`) }}</p>
                    </td>
                  </tr>
                  <tr>
                    <td class="bg-danger">
                      <p class="mb-1">{{ $t("risk.applied-risk-value.high") }}</p>
                      <p class="mb-1">({{ riskRatingDefinition.high.min }}-{{ riskRatingDefinition.highest.max }})</p>
                    </td>
                    <td>
                      <p class="mb-1">{{ $t(`risk.info.point.3`) }}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-popover>

            <div class="w-25 ml-4">
              <h6 class="mt-2">{{ $t("risk.applied-risk-value.text") }}</h6>
              <select disabled class="form-control " v-model="form.appliedRiskValue">
                <option value="LOWEST">{{ $t("risk.applied-risk-value.lowest") }}</option>
                <option value="LOW">{{ $t("risk.applied-risk-value.low") }}</option>
                <option value="MEDIUM">{{ $t("risk.applied-risk-value.medium") }}</option>
                <option value="HIGH">{{ $t("risk.applied-risk-value.high") }}</option>
                <option value="HIGHEST">{{ $t("risk.applied-risk-value.highest") }}</option>
              </select>
            </div>
            <div class="w-25 ml-4">
              <div v-if="form.appliedRiskPoint">
                <h6 class="mt-2">{{ $t("risk.degree.title") }}</h6>
                <div class="legend" style="display: inline!important;">
                  <div v-if="form.degree == 'PREVENT'" class="legend-item">
                    <div class="box bg-danger"></div>
                    <span>{{ $t("risk.degree.prevent") }}</span>
                  </div>
                  <div v-if="form.degree == 'RECOMMEND_PREVENT'" class="legend-item">
                    <div class="box bg-light-warning"></div>
                    <span>{{ $t("risk.degree.recommend-prevent") }}</span>
                  </div>
                  <div v-if="form.degree == 'ACCEPT'" class="legend-item">
                    <div class="box bg-success"></div>
                    <span>{{ $t("risk.degree.accept") }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="r-select-container w-25 mr-4">
              <h6 class="mt-2">{{ $t("risk.target-risk-point") }}</h6>
              <input disabled v-model="form.riskPointGoal" class="form-control" />
            </div>

            <div class="r-select-container w-10 mr-4">
              <h6 class="mt-2">
                {{ $t("risk.applied-risk-decision.text") }}
                <i id="popover-decision" class="bx bx-question-mark rounded-circle ml-2 bg-primary text-white"></i>
              </h6>

              <b-popover container="popover-info" custom-class="wide-popover" target="popover-decision" triggers="hover focus" placement="right">
                <table class="table mb-0">
                  <tbody>
                    <tr>
                      <td>
                        <p class="mb-1">{{ $t("risk.applied-risk-decision.minimize") }}</p>
                      </td>
                      <td>
                        <p v-for="(line, idx) in getdecisionLines(1)" :key="`decision-${1}-${idx}`" class="mb-1">{{ line }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="mb-1">{{ $t("risk.applied-risk-decision.accept") }}</p>
                      </td>
                      <td>
                        <p v-for="(line, idx) in getdecisionLines(2)" :key="`decision-${2}-${idx}`" class="mb-1">{{ line }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="mb-1">{{ $t("risk.applied-risk-decision.avoid") }}</p>
                      </td>
                      <td>
                        <p v-for="(line, idx) in getdecisionLines(3)" :key="`decision-${3}-${idx}`" class="mb-1">{{ line }}</p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <p class="mb-1">{{ $t("risk.applied-risk-decision.transfer") }}</p>
                      </td>
                      <td>
                        <p v-for="(line, idx) in getdecisionLines(4)" :key="`decision-${4}-${idx}`" class="mb-1">{{ line }}</p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-popover>

              <select class="form-control" v-model="form.appliedRiskDecision">
                <option value="ACCEPT">{{ $t("risk.applied-risk-decision.accept") }}</option>
                <option value="AVOID">{{ $t("risk.applied-risk-decision.avoid") }}</option>
                <option value="TRANSFER">{{ $t("risk.applied-risk-decision.transfer") }}</option>
                <option value="MINIMIZE">{{ $t("risk.applied-risk-decision.minimize") }}</option>
              </select>
            </div>

            <div v-if="form.appliedRiskDecision == 'TRANSFER' || form.thirdParty" class="r-select-container mt-2 mr-4" style="width: 21.5%;">
              <right-panel class="float-right" id="sidebar-new-thirdparty" width="600px" :icon="'mdi mdi-plus'" :text="$t('thirdparty.new')" @hidden="rightPanelClosed">
                <div class="pl-5 pr-5">
                  <ThirdPartyForm />
                </div>
              </right-panel>
              <h6>{{ $t("thirdparty.text") }}</h6>
              <filter-select
                id="thirdPartyFilter"
                ref="thirdPartyFilter"
                :selected="form.thirdParty"
                :placeholder="$t('thirdparty.text')"
                :multiple="false"
                @filter="onThirdPartySearch"
                @changed="onThirdPartySelect"
              />
            </div>
            <div class="w-13-3 mr-2 mt-2">
              <h6>{{ $t("risk.budget-plan") }}</h6>
              <input v-model="form.budgetPlan" class="form-control" />
            </div>

            <div class="w-30 mt-2">
              <h6>{{ $t("common.note") }}</h6>
              <textarea v-model="form.preventionPlanNote" type="text" class="form-control" :placeholder="$t('common.note')" rows="3"></textarea>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card v-if="showPrevention" no-body class="custom-card shadow-none custom-accordion">
        <b-card-header header-tag="header" role="tab" class="bg-success2">
          <a v-b-toggle="'accordion_processing'" class="text-dark" href="javascript: void(0);">
            <h5 class="text-dark">
              {{ $t("risk.prevention-plan") }}
            </h5>
          </a>
        </b-card-header>
        <b-collapse
          @show="isAccordionProcessingOpen = true"
          @hidden="isAccordionProcessingOpen = false"
          id="accordion_processing"
          :visible="false"
          style="background-color: #F5F7F9;"
        >
          <div v-if="isAccordionProcessingOpen" class="d-flex flex-wrap mb-4 mt-4 pl-4 pr-4">
            <div class="d-flex flex-wrap flex-grow-0 flex-shrink-0" style="width: calc(100% - 0rem); gap: 1rem;">
              <div class="r-select-container w-100">
                <div class="row">
                  <div class="col-12">
                    <div class=" mb-2">
                      <span class="r-acc-title">
                        {{ $t("risk.related-policy.plural") }}
                      </span>
                      <span class="ml-2 hand text-main" @click="showPolicyPanel = true">
                        <!-- <strong>"{{ $t("risk.policy") }}"</strong> {{ $t("risk.relation") }}
                        <a v-if="enablePoliciesLink" :href="`/${currentProduct.toLowerCase()}/policy?workedFilter=IN_PROGRESS`">{{ $t("policy.plural") }} </a>
                        <span v-else>{{ $t("policy.plural") }}</span> {{ $t("policy.edit-from-page") }}.
                        -->
                        {{ $t("risk.link-with-policy") }} <i class="iconoir-plus font-size-24 align-middle"></i>
                      </span>
                      <div v-if="showPolicyPanel" class="mt-2">
                        <filter-select id="policyFilter" ref="policyFilter" :placeholder="$t('policy.name')" @filter="onPolicySearch" @changed="onPolicySelect" />

                        <b-button @click="linkWithPolicy" :disabled="!selectedPolicy" class="btn-block btn-success mt-3">{{ $t("common.link-with") }}</b-button>
                      </div>
                    </div>

                    <div class="pt-4 ">
                      <div v-if="form.policies && form.policies.length > 0" class="d-flex flex-wrap justify-content-start">
                        <div v-for="policy in form.policies" :key="policy._id" class="pcard p-3 d-flex flex-column mr-4 w-45 card radius">
                          <div class="row">
                            <div class="col-md-7">
                              <div class="pcard--title " style="height: 140px;">
                                <div class="hand" @click="openPolicyDetailModal(policy)">
                                  <h4>{{ $t("policy.name") }}</h4>
                                  {{ policy.name | translate | summary(100) }} <br />
                                </div>
                                <h4 class="mt-3">{{ $t("policy-category.text") }}</h4>
                                <span><policy-category-badge @click="openPolicyDetailModal(policy)" :policy="policy"/></span>
                              </div>
                            </div>

                            <div class="col-md-5">
                              <div v-if="policy.isPeriodical">
                                <div class="float-right" v-b-tooltip.hover :title="$t('policy.period')">
                                  <i class="iconoir-timer align-middle" style="font-size: 1.5rem;"></i>
                                  {{ policy.period }} {{ $t("common.month") }}
                                </div>
                                <br style="clear:both" />
                              </div>
                            </div>
                          </div>

                          <h4>{{ $t("policy.related-compliances") }}</h4>
                          <div class="table-responsive">
                            <table class="table table-bordered table-striped bg-white">
                              <thead class="bg-secondary text-white">
                                <tr>
                                  <td class="">{{ $t("policy.compliance") }}</td>
                                  <td class="">{{ $t("policy-group.text") }}</td>
                                  <td class="">{{ $t("policy.no") }}</td>
                                  <td class="">{{ $t("policy.level") }}</td>
                                  <td class="">{{ $t("policy.definition") }}</td>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="compliance in policy.compliances" :key="compliance._id">
                                  <td>{{ compliance.product }}</td>
                                  <td>{{ compliance.policyGroup.name | translate }}</td>
                                  <td>{{ compliance.policyNo }}</td>
                                  <td>{{ compliance.policyLevel }}</td>
                                  <td>{{ compliance.policyDefinition | translate | summary(100) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div v-if="form.policies && form.policies.length == 0">- {{ $t("risk.related-policies-not-found") }}</div>
                  </div>
                  <div class="col-6">
                    <div class="r-acc-title mb-2">{{ $t("risk.related-tasks") }}</div>
                    <div class="pcard bg-white p-3 mb-3 border">
                      <b-row class="mb-3">
                        <b-col>
                          <div class="text-right">
                            <span @click="showTaskModal()">
                              <a class="m-2" href="javascript:;"> {{ $t("task.create") }} </a></span
                            >
                          </div>
                          <filter-select id="taskFilter" ref="taskFilter" :placeholder="$t('task.name')" @filter="onTaskSearch" @changed="onTaskSelect" />
                        </b-col>
                        <b-col md="3">
                          <b-button @click="linkWithTask" :disabled="!selectedTask" class="btn-block btn-success mt-3">{{ $t("common.link-with") }}</b-button>
                        </b-col>
                      </b-row>
                      <div v-for="policy in form.policies" :key="policy._id">
                        <div v-if="risk" v-for="complianceStatus in policy.complianceStatuses" :key="complianceStatus._id">
                          <div v-if="complianceStatus.risks && complianceStatus.risks.some((i) => i._id.toString() === risk._id.toString())">
                            <div v-for="complianceTask in complianceStatus.tasks">
                              <task-item
                                class="hand"
                                :task="complianceTask"
                                :unlink="false"
                                :disableTooltip="true"
                                :showDates="true"
                                @click="openTaskDetailModal(complianceTask)"
                                @unlinked="removeTaskRiskRelation(complianceTask)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="form.tasks">
                        <div v-for="task in form.tasks" :key="'policy-task-' + task._id" class="bg-white hand">
                          <task-item
                            :end="true"
                            :showDates="true"
                            :task="task"
                            :unlink="true"
                            :disableTooltip="true"
                            @click="openTaskDetailModal(task)"
                            @unlinked="removeTaskRiskRelation(task)"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card v-if="showPrevention" no-body class="custom-card shadow-none custom-accordion">
        <b-card-header header-tag="header" role="tab" class="bg-success2">
          <a v-b-toggle="'accordion_approval'" class="text-dark" href="javascript: void(0);">
            <h5 class="text-dark">
              {{ $t("risk.approval.status") }}
            </h5>
          </a>
        </b-card-header>
        <b-collapse id="accordion_approval" @show="isAccordionApprovalOpen = true" @hidden="isAccordionApprovalOpen = false" :visible="false" style="background-color: #F5F7F9;">
          <div v-if="isAccordionApprovalOpen" class="d-flex flex-wrap mb-4 mt-4 pl-4 pr-4">
            <div class="d-flex flex-wrap flex-grow-0 flex-shrink-0" style="width: calc(100% - 0rem); gap: 1rem;">
              <div class="r-acc-title w-100">
                {{ $t("risk.approval.status") }}

                <span v-if="form.approval" class="font-size-15 text-muted ml-4">
                  <span v-if="form.approval.status == 'PENDING'" class="text-warning"><i class="bx bxs-time align-middle"></i> {{ $t("risk.approval.pending") }} </span>
                  <span v-if="form.approval.status == 'APPROVED'" class="text-success"><i class="bx bxs-check-shield align-middle"></i> {{ $t("risk.approval.approved") }} </span>
                  <span v-if="form.approval.status == 'REJECTED'" class="text-danger"><i class="bx bxs-shield-x align-middle"></i> {{ $t("risk.approval.rejected") }} </span>
                </span>
              </div>
              <div class="r-select-container w-100">
                <div v-if="form.approval" class="d-flex mt-3" style="gap:1rem">
                  <div style="min-width: 18%">
                    <h6>{{ $t("risk.approval.assignee") }}</h6>
                    <letter-avatar :name="form.approval.assignee.name" :image="form.approval.assignee.avatar" variant="primary"> </letter-avatar>
                    <span class="ml-3"> {{ form.approval.assignee.name }}</span>
                    <br />
                    <span class="ml-3 text-muted"> {{ form.approval.assignee.credential.email }}</span>
                  </div>

                  <div style="min-width: 18%">
                    <h6>{{ $t("risk.approval.reporter") }}</h6>
                    <letter-avatar :name="form.approval.reporter.name" :image="form.approval.reporter.avatar" variant="primary"> </letter-avatar>
                    <span class="ml-3"> {{ form.approval.reporter.name }}</span
                    ><br />
                    <span class="ml-3 text-muted"> {{ form.approval.reporter.credential.email }}</span>
                  </div>
                  <div style="min-width: 8%">
                    <h6>{{ $t("risk.approval.at") }}</h6>
                    {{ form.approval.at | date }}
                  </div>

                  <div v-if="hasResolvePermission" style="min-width: 8%">
                    <h6>{{ $t("risk.approval.status") }}</h6>

                    <select class="form-control " v-model="approvalStatus">
                      <option value="PENDING">{{ $t("risk.approval.pending") }}</option>
                      <option value="APPROVED">{{ $t("risk.approval.approved") }}</option>
                      <option value="REJECTED">{{ $t("risk.approval.rejected") }}</option>
                    </select>

                    <sweet-button
                      v-if="hasResolvePermission"
                      @click="resolveApproval()"
                      buttonClass="mt-3"
                      :disabled="isSendingApproval"
                      :loading="isSendingApproval"
                      variant="success"
                      size="sm"
                      :block="true"
                      icon="fa fa-check"
                    >
                      {{ $t("risk.approval.resolve") }}
                    </sweet-button>
                  </div>
                  <div v-if="form.approval && form.approval.status == 'PENDING'" style="min-width: 21%">
                    <h6>{{ $t("common.note") }}</h6>
                    <textarea v-model="approvalNote" :disabled="!hasResolvePermission" type="text" class="form-control" :placeholder="$t('common.note')" rows="4"></textarea>
                  </div>
                </div>

                <div v-if="!form.approval || form.approval.status != 'PENDING'" class="mt-5" style="gap:1rem">
                  <div class="r-acc-title mb-2">{{ $t("risk.approval.send") }}</div>
                  <div class="r-select-container">
                    <h6>{{ $t("risk.approval.assignee") }}</h6>

                    <organization-member-select class="d-block" @onSelect="onLegalAdminSelect" :filterFunction="approvalFilterFunction" />
                  </div>
                  <div class="w-50">
                    <h6 class="mt-3">{{ $t("common.note") }}</h6>
                    <textarea v-model="approvalNote" type="text" class="form-control" :placeholder="$t('common.note')" rows="2"></textarea>

                    <sweet-button
                      @click="sendApproval()"
                      :disabled="isSendingApproval || !approvalAssignee"
                      :loading="isSendingApproval"
                      variant="success"
                      size="sm"
                      :block="true"
                      buttonClass="mt-2"
                      icon="mdi mdi-check"
                    >
                      {{ $t("risk.approval.send") }}
                    </sweet-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <b-card v-if="showPreventionAndHistory" no-body class="custom-card shadow-none custom-accordion">
        <b-card-header header-tag="header" role="tab" class="bg-danger">
          <a v-b-toggle="'accordion_history'" class="text-dark" href="javascript: void(0);">
            <h5 class="text-dark">
              {{ $t("risk.history") }}
            </h5>
          </a>
        </b-card-header>
        <b-collapse @show="isAccordionHistoryOpen = true" @hidden="isAccordionHistoryOpen = false" id="accordion_history" :visible="false" style="background-color: #F5F7F9;">
          <div v-if="isAccordionHistoryOpen" class="d-flex flex-wrap mb-4 mt-4 pl-4 pr-4">
            <div class="d-flex flex-wrap flex-grow-0 flex-shrink-0" style="width: 100%; gap: 1rem;">
              <div v-if="historyItems && historyItems.length > 0" class="edit-card" style="overflow-x: auto;">
                <table class="table table-bordered table-striped">
                  <thead class="bg-secondary text-white">
                    <tr>
                      <th style="width: 150px">{{ $t("common.at") }}</th>
                      <th style="width: 150px;">{{ $t("common.updated-by") }}</th>
                      <th style="width: 150px;">{{ $t("risk.updater-product") }}</th>
                      <th style="width: 150px;">{{ $t("risk.approval.status") }}</th>
                      <th style="width: 170px;">{{ $t("risk.approval.reporter") }}</th>
                      <th style="width: 170px;">{{ $t("risk.approval.assignee") }}</th>
                      <th style="width: 170px;">{{ $t("common.at") }}</th>
                      <th style="width: 500px;">{{ $t("risk.approval.note") }}</th>
                      <th style="width: 500px;">{{ $t("risk.definition.text") }}</th>
                      <th style="width: 140px;">{{ $t("risk.category.text") }}</th>
                      <th style="width: 250px;">{{ $t("risk.owner") }}</th>
                      <th style="width: 250px;">{{ $t("risk.data-owner") }}</th>
                      <th style="width: 250px;">{{ $t("asset-group-category.text") }}</th>
                      <th style="width: 250px;">{{ $t("asset-group.text") }}</th>

                      <th style="width: 250px;">{{ $t("risk.admin") }}</th>
                      <th style="width: 250px;">{{ $t("risk.source.text") }}</th>

                      <th style="width: 170px;">{{ $t("risk.status.text") }}</th>
                      <th style="width: 130px;">{{ $t("risk.possibility") }}</th>
                      <th style="width: 130px;">{{ $t("risk.effect") }}</th>
                      <th style="width: 130px;">{{ $t("risk.risk-point") }}</th>
                      <th style="width: 130px;">{{ $t("risk.target-risk-point") }}</th>
                      <th style="width: 130px;">{{ $t("risk.budget-plan") }}</th>
                      <th style="width: 140px;">{{ $t("risk.applied-risk-value.text") }}</th>
                      <th style="width: 140px;">{{ $t("risk.applied-risk-decision.text") }}</th>
                      <th style="width: 140px;">{{ $t("thirdparty.text") }}</th>
                      <th style="width: 300px;">{{ $t("common.note") }}</th>
                      <th style="width: 300px;">{{ $t("risk.threat-definition.text") }}</th>
                      <th style="width: 300px;">{{ $t("risk.weakness-definition.text") }}</th>
                      <th style="width: 300px;">{{ $t("risk.applied-control.plural") }}</th>
                      <th style="width: 500px;">{{ $t("risk.prevention-plan-note") }}</th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr v-for="item in historyItems" :key="item._id">
                      <td>
                        <b v-if="item.latest">
                          {{ $t("common.current") }}
                          <br />
                        </b>

                        {{ item.updatedAt | date(true) }}
                      </td>
                      <td :class="{ diff: item.changes.includes('updatedBy') }">
                        {{ item.updatedBy ? item.updatedBy.name : "-" }}
                      </td>
                      <td :class="{ diff: item.changes.includes('causedProduct') }">
                        {{ item.causedProduct }}
                      </td>
                      <template v-if="item.approval">
                        <td :class="{ diff: item.changes.includes('approval') }">
                          <span v-if="item.approval.status == 'PENDING'" class="text-warning"><i class="bx bxs-time align-middle"></i> {{ $t("risk.approval.pending") }} </span>
                          <span v-if="item.approval.status == 'APPROVED'" class="text-success"
                            ><i class="bx bxs-check-shield align-middle"></i> {{ $t("risk.approval.approved") }}
                          </span>
                          <span v-if="item.approval.status == 'REJECTED'" class="text-danger"
                            ><i class="bx bxs-shield-x align-middle"></i> {{ $t("risk.approval.rejected") }}
                          </span>
                        </td>
                        <td :class="{ diff: item.changes.includes('approval') }">{{ item.approval.reporter.name }}</td>
                        <td :class="{ diff: item.changes.includes('approval') }">{{ item.approval.assignee.name }}</td>
                        <td :class="{ diff: item.changes.includes('approval') }">{{ item.approval.at | date(true) }}</td>
                        <td :class="{ diff: item.changes.includes('approval') }" style="width: auto;">{{ item.approval.note | translate }}</td>
                      </template>
                      <template v-else>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </template>
                      <td :class="{ diff: item.changes.includes('name') }">{{ item.name | translate }}</td>
                      <td :class="{ diff: item.changes.includes('category') }"><risk-category-badge :risk="item" /></td>
                      <td :class="{ diff: item.changes.includes('owner') }">
                        <span v-if="item.owner">{{
                          item.owner == "ORGANIZATION" ? $t("organization.text") : item.owner == "DEPARTMENT" ? $t("department.text") : $t("process.text")
                        }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('dataOwner') }">{{ item.dataOwner ? dataOwnerName(item.dataOwner) : "-" }}</td>

                      <td :class="{ diff: item.changes.includes('assetGroupCategories') }">
                        <span v-if="item.assetGroupCategories"> {{ displayAssetGroupCategoriesInHistory(item.assetGroupCategories) }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('assetGroups') }">
                        <span v-if="item.assetGroups">{{ displayAssetGroupsInHistory(item.assetGroups) }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('admin') }">
                        <span v-if="item.admin">{{ item.admin.name }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('source') }">
                        <span v-if="item.source">{{ displayRiskSource(item.source) }}</span>
                      </td>

                      <td :class="{ diff: item.changes.includes('status') }">
                        <span v-if="item.status == 'ACTIVE'">{{ $t("risk.status.active") }}</span>
                        <span v-if="item.status == 'INACTIVE'">{{ $t("risk.status.inactive") }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('possibility') }">
                        <span v-if="item.possibility"> {{ stringifyPossibility(item.possibility) }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('effectValue') }">{{ item.effectValue }}</td>
                      <td :class="{ diff: item.changes.includes('appliedRiskPoint') }">{{ item.appliedRiskPoint }}</td>
                      <td :class="{ diff: item.changes.includes('riskPointGoal') }">{{ item.riskPointGoal | translate }}</td>
                      <td :class="{ diff: item.changes.includes('budgetPlan') }">{{ item.budgetPlan | translate }}</td>
                      <td :class="{ diff: item.changes.includes('appliedRiskValue') }">
                        <span v-if="item.appliedRiskValue == 'LOWEST'">{{ $t("risk.applied-risk-value.lowest") }}</span>
                        <span v-if="item.appliedRiskValue == 'LOW'">{{ $t("risk.applied-risk-value.low") }}</span>
                        <span v-if="item.appliedRiskValue == 'MEDIUM'">{{ $t("risk.applied-risk-value.medium") }}</span>
                        <span v-if="item.appliedRiskValue == 'HIGH'">{{ $t("risk.applied-risk-value.high") }}</span>
                        <span v-if="item.appliedRiskValue == 'HIGHEST'">{{ $t("risk.applied-risk-value.highest") }}</span>
                      </td>

                      <td :class="{ diff: item.changes.includes('appliedRiskDecision') }">
                        <span v-if="item.appliedRiskDecision == 'ACCEPT'">{{ $t("risk.applied-risk-decision.accept") }}</span>
                        <span v-if="item.appliedRiskDecision == 'AVOID'">{{ $t("risk.applied-risk-decision.avoid") }}</span>
                        <span v-if="item.appliedRiskDecision == 'TRANSFER'">{{ $t("risk.applied-risk-decision.transfer") }}</span>
                        <span v-if="item.appliedRiskDecision == 'MINIMIZE'">{{ $t("risk.applied-risk-decision.minimize") }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('thirdParty') }">
                        <span v-if="item.thirdParty">{{ $options.filters.translate(item.thirdParty.name) }}</span>
                      </td>
                      <td :class="{ diff: item.changes.includes('note') }">{{ item.note | translate }}</td>

                      <td :class="{ diff: item.changes.includes('threats') }">
                        <span v-for="(control, index) in item.threats" :key="control._id"
                          >{{ control.name | translate }} <span v-if="index !== item.threats.length - 1">, </span>
                        </span>
                      </td>
                      <td :class="{ diff: item.changes.includes('weaknesses') }">
                        <span v-for="(control, index) in item.weaknesses" :key="control._id"
                          >{{ control.name | translate }} <span v-if="index !== item.weaknesses.length - 1">, </span>
                        </span>
                      </td>

                      <td :class="{ diff: item.changes.includes('appliedControl') }">
                        <span v-for="(control, index) in item.appliedControl" :key="control._id"
                          >{{ control.name | translate }} <span v-if="index !== item.appliedControl.length - 1">, </span>
                        </span>
                      </td>

                      <td :class="{ diff: item.changes.includes('preventionPlanNote') }">{{ item.preventionPlanNote | translate }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </b-collapse>
      </b-card>

      <div class="justify-content-end d-flex">
        <sweet-button v-if="!isCreating" @click="deleteById()" :disabled="isDisabled" :loading="isUpdating" variant="danger" size="lg" icon="mdi mdi-delete">
          {{ $t("common.delete") }}
        </sweet-button>
        <sweet-button
          @click="save()"
          buttonClass="ml-2"
          :disabled="isDisabled || $v.$invalid || !calculateButtonClicked"
          :loading="isUpdating"
          variant="success"
          size="lg"
          icon="mdi mdi-check"
        >
          {{ $t("common.save") }}
        </sweet-button>
        <sweet-button @click="cancel()" buttonClass="ml-2" :disabled="isDisabled" :loading="isUpdating" variant="secondary" size="lg" icon="mdi mdi-cancel">
          {{ $t("common.cancel") }}
        </sweet-button>
      </div>
    </div>
  </div>
</template>

<script>
import PropertyUtil from "@/helpers/property-util";
import SweetTextarea from "@c/form/sweet-textarea";
import ModalSelect from "@c/modal-select";
import OrganizationMemberSelect from "@cc/organization-member-select";
import { required } from "vuelidate/lib/validators";
import PolicyCategoryBadge from "../policy/component/policy-category-badge";
import PolicyDetail from "../policy/component/policy-detail";
import PolicyStatusSelect from "../policy/component/policy-status-select";
import ThirdPartyForm from "../thirdparty/organization-thirdparty-form.vue";
import AppliedRiskValueBadge from "./component/applied-risk-value-badge";
import RiskCategoryBadge from "./component/risk-category-badge";
import OrganizationRiskAppliedControlForm from "./organization-risk-applied-control-form.vue";
import OrganizationRiskThreatDefinitionForm from "./organization-risk-threat-definition-form.vue";
import OrganizationRiskWeaknessDefinitionForm from "./organization-risk-weakness-definition-form.vue";
import RiskAppliedControlRecommendation from "./risk-applied-control-recommendation";
import RiskAssetGroupRelationForm from "./risk-asset-group-relation-form";

export default {
  components: {
    RiskCategoryBadge,
    PolicyStatusSelect,
    PolicyCategoryBadge,
    AppliedRiskValueBadge,
    ModalSelect,
    OrganizationMemberSelect,
    PolicyDetail,
    SweetTextarea,
    ThirdPartyForm,
    RiskAssetGroupRelationForm,
    RiskAppliedControlRecommendation,
    OrganizationRiskAppliedControlForm,
    OrganizationRiskThreatDefinitionForm,
    OrganizationRiskWeaknessDefinitionForm,
  },
  validations: {
    form: {
      name: {
        required,
      },
      admin: {
        required,
      },
      appliedRiskDecision: {
        required,
      },
    },
  },

  props: ["hideGoBack"],
  data() {
    return {
      productAdminMap: {
        KVKK: "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        GDPR: "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        BGYS: "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        DDO: "ORGANIZATION_DDO_PRODUCT_ADMIN",
      },
      form: {
        category: "ADMINISTRATIVE",
        status: "RATING",
        appliedRiskDecision: undefined, // "AVOID",
        source: undefined,
        degree: undefined,
        owner: undefined,
        admin: undefined,
        responsible: undefined,
        dataOwner: { organiation: undefined, department: undefined, process: undefined },
        products: this.currentProduct ? [this.currentProduct == "RISK" ? "PLATFORM" : this.currentProduct] : [],
      },
      riskAssetGroupRequest: {
        options: { page: 1, limit: 10 },
        query: {},
      },
      highestRatedRelation: undefined,
      libraryDefinitionQuery: { category: { value: "ADMINISTRATIVE", isObject: true } },
      effectValueOptions: [],
      riskDecisionProposal: undefined,
      approvalStatus: undefined,
      approvalNote: undefined,
      approvalAssignee: undefined,
      selectedTask: undefined,
      calculateButtonClicked: false,
      showPolicyPanel: false,
      selectedPolicy: undefined,
      historyItems: [],
      initialStatus: undefined,
      isThereUnsavedChange: false,
      isAccordionAnalysisOpen: true,
      isAccordionProcessingOpen: false,
      isAccordionApprovalOpen: false,
      isAccordionHistoryOpen: false,
      reloadMessage: this.$t("common.reload-message"),
      previousName: undefined,
    };
  },

  computed: {
    appliedControlproductQuery() {
      return { products: { value: { $in: this.form.products || [] }, isObject: true } };
    },
    showRelatedAssetGroup() {
      return this.form.name && this.form.threats && this.form.weaknesses;
    },

    isPossibilityDisabled() {
      return this.highestRatedRelation || (this.riskAssetGroupPagination && this.riskAssetGroupPagination.docs.length > 0);
    },
    enablePoliciesLink() {
      const result = ["KVKK", "GDPR", "BGYS"].some((i) => i == this.currentProduct);
      return result;
    },
    isLoading() {
      return this.$store.getters["organizationRisk/isLoading"];
    },
    isAcceptableRisk() {
      return this.form.degree === "ACCEPT";
    },
    isCalculating() {
      return this.$store.getters["organizationRisk/isCalculating"];
    },
    isCalculateButtonActive() {
      return !this.isCalculating && this.form.effectValue && this.form.possibility;
    },

    isDisabled() {
      return this.isLoading;
    },
    isUpdating() {
      return this.$store.getters["organizationRisk/isUpdating"];
    },
    isCreating() {
      return this.$store.getters["organizationRisk/isCreating"];
    },
    risk() {
      return this.$store.getters["organizationRisk/risk"];
    },
    legalAdmins() {
      return this.$store.getters["organizationMember/pagination"]?.docs ?? [];
    },
    riskAssetGroupPagination() {
      return this.$store.getters["organizationRiskAssetGroupRelation/pagination"];
    },
    isSendingApproval() {
      return this.$store.getters["organizationMember/isSendingApproval"];
    },
    riskRatingDefinition() {
      return this.$store.getters[`organizationRisk/riskRatingDefinition`];
    },
    hasRiskAdminPermission() {
      return this.currentAccountHasPermissions([
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
      ]);
    },
    hasResolvePermission() {
      if (this.form?.approval?.status != "PENDING") {
        return false;
      }

      if (this.form?.approval?.assignee?._id?.toString() == this.currentAccount._id.toString()) {
        return true;
      }

      return false;
    },

    showPreventionAndHistory() {
      return this.form._id; //&& (this.initialStatus == "ACTIVE" || this.initialStatus == "INACTIVE");
    },
    showPrevention() {
      return this.form._id || this.form.originalId; //this.form._id && (this.form.degree === "RECOMMEND_PREVENT" || this.form.degree === "PREVENT" || this.initialStatus == "INACTIVE");
    },
  },
  watch: {
    risk: {
      deep: true,
      immediate: true,
      handler(v, o) {
        this.form = {
          dataOwner: { organiation: undefined, department: undefined, process: undefined },
          navigatedByAddFromLibaray: v?.navigatedByAddFromLibaray,
          ...this.prepareFormForEdit(v, ["note", "riskPointGoal", "budgetPlan", "preventionPlanNote", "currentControls"]),
        };
        if (v) {
          this.previousName = v.name?.[this.currentLanguage];
          this.debounce(() => this.paginateRiskAssetGroupRelation());
          if (!o) {
            this.onDefinitionBlur();
          }
        }
      },
    },
    "form.status": {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.form.status = "RATING";
        }
      },
    },
    "form.appliedRiskDecision": {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          this.form.appliedRiskDecision = "MINIMIZE";
        }
      },
    },

    riskAssetGroupRequest: {
      deep: true,
      immediate: true,

      handler() {
        this.debounce(() => this.paginateRiskAssetGroupRelation());
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(v, o) {
        this.$store.commit("organizationRisk/form", { ...v });
        if (v) {
          this.isThereUnsavedChange = true;

          if (!this.initialStatus && v._id) {
            this.initialStatus = v.status;
          }
          if (v._id) {
            this.calculateButtonClicked = true;
          }
          // if (!v._id && v.degree !== "ACCEPT") {
          //   v.status = "ACTIVE";
          // }
        }
        if (v?.approval) {
          if (v.approval.status != "REJECTED" && v.approval.status != "APPROVED") {
            this.approvalNote = v.approval.note ? v.approval?.note[this.currentLanguage] : undefined;

            this.approvalStatus = v.approval.status;
          }
        }
      },
    },
    riskAssetGroupPagination: {
      deep: true,
      handler(v) {
        this.fetchHighestRatedRelation();
      },
    },
    "form.effectValue": {
      deep: true,
      handler(v, o) {
        if (v != o) {
          this.calculateButtonClicked = false;
        }
      },
    },
    "form.possibility": {
      deep: true,
      handler(v, o) {
        if (v != o) {
          this.calculateButtonClicked = false;
        }
      },
    },
    highestRatedRelation: {
      deep: true,
      handler(v, o) {
        if (v && o) {
          this.calculateButtonClicked = false;
        }
      },
    },
    "form.dataOwner": {
      deep: true,
      handler(v) {
        if (v) {
          if (this.form.dataOwner.department) {
            this.form.admin = this.form.dataOwner.department.admins?.[0]?.account || this.form.admin;
          }
          if (this.form.dataOwner.process) {
            this.form.admin = this.form.dataOwner.process.admins?.[0]?.account || this.form.admin;
          }
        }
      },
    },
    "form.category": {
      deep: true,
      immediate: true,
      handler(v, o) {
        if (v) {
          this.libraryDefinitionQuery = { ...this.libraryDefinitionQuery, category: { value: v, isObject: true } };
        } else {
          this.form.category = "ADMINISTRATIVE";
        }
      },
    },
  },
  async mounted() {
    await this.init();
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnload);
  },

  async beforeRouteLeave(to, from, next) {
    if (!this.isThereUnsavedChange) {
      next();
      this.$store.commit("organizationRisk/reset");
      return;
    }
    const answer = await this.confirm(this.reloadMessage);
    if (answer) {
      this.$store.commit("organizationRisk/reset");
      next();
    } else {
      next(false);
    }
  },
  methods: {
    getAppliedRiskValueKey(level) {
      const map = {
        1: "risk.applied-risk-value.lowest",
        2: "risk.applied-risk-value.low",
        3: "risk.applied-risk-value.medium",
        4: "risk.applied-risk-value.high",
        5: "risk.applied-risk-value.highest",
      };

      return map[level] || "risk.applied-risk-value.lowest";
    },
    getPossibilityLines(level) {
      const raw = this.$t(`risk.info.possibility.${level}`);

      if (!raw || typeof raw !== "string") {
        return [];
      }

      return raw
        .split(/\n+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    },
    getdecisionLines(level) {
      const raw = this.$t(`risk.info.decision.${level}`);

      if (!raw || typeof raw !== "string") {
        return [];
      }

      return raw
        .split(/\n+/)
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
    },
    onAppliedControlSaved() {
      this.$refs.appliedControlFilter?.searchChanged("*");
    },
    applyRecommendation(items) {
      const arr = [...(this.form.appliedControl || []), ...items];
      const uniqueArray = [...new Map(arr.map((item) => [item._id, item])).values()];

      this.form = {
        ...this.form,
        appliedControl: uniqueArray,
      };
    },
    async onThreatDefinitionSearch(value, callback) {
      const response = await this.$store.dispatch(`riskThreatDefinition/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onThreatDefinitionSelect(threats) {
      this.form = { ...this.form, threats };
    },
    async onWeaknessDefinitionSearch(value, callback) {
      const response = await this.$store.dispatch(`riskWeaknessDefinition/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onWeaknessDefinitionSelect(weaknesses) {
      this.form = { ...this.form, weaknesses };
    },
    redirectToRelatedFiles(item) {
      const url = this.currentProduct ? `/${this.currentProduct.toLowerCase()}/file-manager` : "/organization/file-manager";
      this.$router.push({ path: url, query: { risk: item._id, riskName: item.name?.[this.currentLanguage] } });
    },
    displayRiskSource(text) {
      if (text == "INTENTIONAL_UNINTENTIONAL_COMPELLING") {
        return this.$t("risk.source.intentional-unintentional-compelling");
      } else if (text == "UNINTENTIONAL") {
        return this.$t("risk.source.unintentional");
      } else if (text == "INTENTIONAL_UNINTENTIONAL") {
        return this.$t("risk.source.intentional-unintentional");
      } else if (text == "INTENTIONAL") {
        return this.$t("risk.source.intentional");
      } else if (text == "COMPELLING") {
        return this.$t("risk.source.compelling");
      } else {
        return "";
      }
    },
    assetGroupRelationSaved() {
      this.fetchDetail();
    },
    onThreatSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-threat-definition");
      this.$refs?.threatFilter?.searchChanged("*");
    },
    onWeaknessSaved() {
      this.$root.$emit("bv::toggle::collapse", "sidebar-weakness-definition");
      this.$refs?.weaknessFilter?.searchChanged("*");
    },
    displayAssetGroupCategoriesInHistory(assetGroupCategories) {
      return assetGroupCategories?.map((category) => this.$options.filters.translate(category.name)).join(", ") || "";
    },
    displayAssetGroupsInHistory(assetGroups) {
      return assetGroups?.map((assetGroup) => this.$options.filters.translate(assetGroup.name)).join(", ") || "";
    },
    goBack() {
      if (this.$route.query.goBackPath) {
        window.location.href = `${window.location.origin}/${this.$route.query.goBackPath}`;
      } else {
        this.$router.push(`/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/risk`);
      }
    },
    async linkWithPolicy() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        this.save(false, false);

        await this.$store.dispatch("organizationPolicy/addPolicyRiskRelation", {
          policyId: this.selectedPolicy._id,
          riskId: this.form._id,
        });

        this.selectedPolicy = undefined;
        this.showPolicyPanel = false;

        this.$forceUpdate();
        this.$toast.success(this.$t("common.success"));

        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async fetchHighestRatedRelation() {
      try {
        const request = {
          options: { page: 1, limit: 1, sort: { riskPoint: "desc" } },
          query: { risk: { value: this.risk?._id || this.form?.risk?._id, isObject: true } },
        };

        const relation = await this.$store.dispatch("organizationRiskAssetGroupRelation/fetchHighestRatedRelation", request);
        if (relation) {
          this.form.possibility = relation.possibility;
          this.form.effectValue = relation.effectValue;
          this.criticalityLevel = relation.criticalityLevel;
        } else {
          this.highestRatedRelation = undefined;
        }
      } catch (error) {}
    },
    //TODO bu metot performans sorunlarına neden olabilir
    approvalFilterFunction(item) {
      const permissionFilter = new Set(["ORGANIZATION_ADMIN", "ORGANIZATION_LEGAL_ADMIN", "ORGANIZATION_RISK_ADMIN"]);

      let isDepartmentAdmin = false;
      let isProcessAdmin = false;

      if (this.form.owner === "ORGANIZATION") {
        this.form.products?.forEach((product) => {
          if (!["PLATFORM", "RISK"].includes(product)) {
            permissionFilter.add(this.productAdminMap[product]);
          }
        });
      } else if (this.form.owner === "DEPARTMENT") {
        const departmentAdminAcl = this.form?.dataOwner?.department?.admins?.[0];
        isDepartmentAdmin = departmentAdminAcl && item._id === departmentAdminAcl._id;
      } else if (this.form.owner === "PROCESS") {
        const process = item.processAdminOf.find((i) => i.process?._id == this.form?.dataOwner?.process._id);
        const processAdminAcl = process ? item : undefined;

        isProcessAdmin = processAdminAcl && item._id === processAdminAcl._id;
        const hierarchicalAccess = item?.departmentAdminOf?.some((j) => j?.processes?.some((i) => i.process._id == this.form?.dataOwner?.process._id));

        isProcessAdmin = isProcessAdmin || hierarchicalAccess;
      }

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return isDepartmentAdmin || isProcessAdmin || item.isOwner || hasValidRole;
    },
    filterFunction(item) {
      const departmentAdminAcl = this.form?.dataOwner?.department?.admins?.[0];

      const permissionFilter = new Set([
        "ORGANIZATION_ADMIN",
        "ORGANIZATION_GDPR_PRODUCT_ADMIN",
        "ORGANIZATION_GDPR_ACCESS",
        "ORGANIZATION_KVKK_PRODUCT_ADMIN",
        "ORGANIZATION_KVKK_ACCESS",
        "ORGANIZATION_BGYS_PRODUCT_ADMIN",
        "ORGANIZATION_DDO_PRODUCT_ADMIN",
        "ORGANIZATION_INFORMATION_TECHNOLOGY_ADMIN",
        "ORGANIZATION_RISK_ADMIN",
        "ORGANIZATION_LEGAL_ADMIN",
      ]);

      const isDepartmentAdmin = departmentAdminAcl && item._id === departmentAdminAcl._id;

      const hasValidRole = item.accessable && item.roles?.some((role) => role.permissions?.some((permission) => permissionFilter.has(permission)));

      return isDepartmentAdmin || item.isOwner || hasValidRole;
    },
    async init() {
      this.libraryDefinitionQuery = { ...this.libraryDefinitionQuery, products: { value: { $in: [this.currentProduct] }, isObject: true } };
      this.beforeUnload = this.beforeUnload.bind(this);
      window.addEventListener("beforeunload", this.beforeUnload);
      await this.fetchRiskRatingDefinition();
      await this.paginateRiskAssetGroupRelation();

      if (this.$route.params.id) {
        this.$store.commit("organizationRisk/isEditing", true);

        await this.paginateRiskAssetGroupRelation();
        await this.fetchDetail();
        //this.calculate();
      } else {
        this.$store.commit("organizationRisk/isCreating", true);

        this.onDefinitionBlur();
      }
      this.form.products = this.currentProduct ? [this.currentProduct == "RISK" ? "PLATFORM" : this.currentProduct] : [];
    },
    async fetchRiskRatingDefinition() {
      const data = await this.$store.dispatch(`organizationRisk/fetchRiskRatingDefinition`);
      this.$store.commit("organizationRisk/editedRatingDefinition", { ...data });
    },
    async editAssetGroupRelation(item) {
      this.$root.$emit("bv::toggle::collapse", "sidebar-new-asset-group");
      this.$store.commit("organizationRiskAssetGroupRelation/editedEntity", item);
    },
    async handleRelationWithRiskCreated(data) {
      if (!data || !data?.risk?._id) {
        return;
      }
      this.isThereUnsavedChange = false;
      this.fetchDetail();
      // window.location.href = `/${this.currentProduct.toLowerCase()}/risk-detail/${data.risk._id}`;
    },
    onMemberSelect(item) {
      this.form = { ...this.form, admin: item };
    },
    dataOwnerName(item) {
      let name = "";
      if (item.organization) {
        name = item.organization.name;
      } else if (item.department) {
        name = item.department.name[this.currentLanguage];
      } else if (item.process) {
        name = item.process.name[this.currentLanguage];
      }
      return name;
    },

    ownerChanded(e) {
      if (e.target.value == "ORGANIZATION") {
        this.onOrganizationSelect();
      }
      setTimeout(() => {
        this.$refs?.departmentFilter?.reset();
        this.$refs?.processFilter?.reset();
      }, 500);
    },
    async paginateRiskAssetGroupRelation() {
      if (!this.form._id) {
        return;
      }
      const request = { ...this.riskAssetGroupRequest, query: { ...this.riskAssetGroupRequest.query, risk: { value: this.form._id, isObject: true } } };
      this.$store.dispatch(`organizationRiskAssetGroupRelation/paginate`, request);
    },
    async fetchDetail() {
      const id = this.$route.params.id || this.form._id;
      try {
        await this.$store.dispatch("organizationRisk/fetchDetail", id);

        this.$store.commit("organizationRisk/editedEntity", this.risk);
        this.buildHistory();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async fetchFromLibrary(name) {
      //Kütüphanedeki kayıtların da bulunup formun doldurulması için. Hile hurda..
      let { data } = await this.$store.dispatch(`riskDefinition/paginateForSearch`, { limit: 1, query: { name: { value: name } } });
      const risk = data.docs?.[0];
      if (risk) {
        return {
          category: risk.category,
          name: risk.name,
          threats: risk.threats,
          weaknesses: risk.weaknesses,
          libraryItem: risk,
          _id: risk._id,
          products: [this.currentProduct],
        };
      }
    },
    async onDefinitionBlur() {
      try {
        if (!this.form.name || this.form.name.trim() == "") {
          return;
        }

        let organizationRisk = await this.fetchRiskDetailByDefinition(this.form.name, this.form.navigatedByAddFromLibrary && this.form.libraryItem);
        if (!organizationRisk) {
          if (!this.form.name) {
            return;
          }

          //Kütüphanedeki kayıtların da bulunup formun doldurulması için. Hile hurda..
          const libraryRisk = await this.fetchFromLibrary(this.form.name);

          if (libraryRisk && (this.form.libraryItem?._id || this.form.libraryItem) != libraryRisk._id) {
            // this.form.name = undefined;
            this.form.name = this.previousName;
            this.$toast.warning(this.$t("risk.conflict", { name: libraryRisk?.name?.[this.currentLanguage] }), { timeout: 3000 });
            return;
          }
        }
        if (this.form.navigatedByAddFromLibrary && organizationRisk && organizationRisk?.status != "RATING") {
          this.$root.$emit("bv::toggle::collapse", "sidebar-add-new-risk");
          this.$toast.warning(this.$t("risk.add-from-library-conflict", { name: organizationRisk?.name?.[this.currentLanguage] }), { timeout: 3000 });
          return;
        }

        if (organizationRisk) {
          if ((this.form._id && organizationRisk._id != this.form._id) || (this.form.originalId && organizationRisk.libraryItem != this.form.originalId)) {
            // this.form.name = undefined;
            this.form.name = this.previousName;
            this.$toast.warning(this.$t("risk.conflict", { name: organizationRisk?.name?.[this.currentLanguage] }), { timeout: 3000 });
            return;
          }

          this.handleExistingRisk({ ...organizationRisk, originalId: this.form.originalId });
        }
      } catch (error) {
        console.error(error);
      }
    },
    async fetchRiskDetailByDefinition(definition, libraryItem) {
      try {
        const data = await this.$store.dispatch("organizationRisk/fetchDetailByDefinition", { definition, libraryItem: libraryItem?._id || libraryItem });

        if (data && data._id) {
          return data;
        } else {
          return undefined;
        }
      } catch (error) {}
    },
    stringifyPossibility(possibility) {
      return possibility == 1
        ? this.$t("risk.applied-risk-value.lowest")
        : possibility == 2
        ? this.$t("risk.applied-risk-value.low")
        : possibility == 3
        ? this.$t("risk.applied-risk-value.medium")
        : possibility == 4
        ? this.$t("risk.applied-risk-value.high")
        : this.$t("risk.applied-risk-value.highest");
    },
    showTaskModal() {
      this.$store.commit("task/showTaskDetailModal", true);
      this.$store.commit("task/isCreating", true);
    },

    async save(confirm = true, alert = true) {
      if (confirm) {
        const ok = await this.$root.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        if ((!this.form.products || this.form.products.length == 0) && this.currentProduct) {
          this.form.products = [this.currentProduct];
        }
        if (this.form.effectValue && this.form.possibility) {
          await this.calculate();
        }

        const raw = this.$store.getters["organizationRisk/form"];
        //->gereksiz alanları temizle.
        const form = {
          ...raw,
        };
        delete form.history;
        delete form.policies;
        delete form.tasks;
        delete form.approval;
        //<--

        const { data } = await this.$store.dispatch("organizationRisk/save", form);
        this.isThereUnsavedChange = false;
        if (alert) {
          this.$toast.success(this.$t("common.success"));
        }

        //this.$store.commit("organizationRisk/reset");
        this.$store.commit("organizationRisk/riskId", data._id);
        if (!this.form._id && this.$route.path.includes("/risk/create")) {
          // window.location.href = `/${this.currentProduct ? this.currentProduct.toLowerCase() : "organization"}/risk-detail/${data._id}`;
          this.$router.push(`/${this.currentProduct.toLowerCase()}/risk-detail/${data._id}`);
        } else {
          this.form = {
            ...this.prepareFormForEdit(data, ["note", "riskPointGoal", "budgetPlan", "preventionPlanNote", "currentControls"]),
          };
          this.$store.commit("organizationRisk/risk", data);
          this.buildHistory();
        }
        this.$emit("onSave", data);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async cancel() {
      this.$router.push(`/${this.currentProduct.toLowerCase()}/risk`);
    },

    async deleteById() {
      const id = this.$route.params.id;
      if (!id) {
        return;
      }

      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRisk/delete`, id);
        this.$toast.success(this.$t("common.delete-successful"));
        this.$router.push(`/${this.currentProduct.toLowerCase()}/risk`);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async sendApproval() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        if (!this.approvalAssignee?._id) {
          this.$toast.warning(this.$t("risk.approval-assignee-required"));
        }
        await this.$store.dispatch(`organizationRisk/sendApproval`, {
          id: this.risk._id,
          assignee: this.approvalAssignee,
          note: {
            [this.currentLanguage]: this.approvalNote,
          },
        });
        this.$toast.success(this.$t("common.successful"));

        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async resolveApproval() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRisk/resolveApproval`, {
          id: this.risk._id,
          status: this.approvalStatus,
          note: {
            [this.currentLanguage]: this.approvalNote,
          },
        });
        this.$toast.success(this.$t("common.successful"));
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    riskDecisionText(value) {
      let text;
      if (value == "ACCEPT") {
        text = this.$t("risk.applied-risk-decision.accept");
      } else if (value == "AVOID") {
        text = this.$t("risk.applied-risk-decision.avoid");
      } else if (value == "TRANSFER") {
        text = this.$t("risk.applied-risk-decision.transfer");
      } else if (value == "MINIMIZE") {
        text = this.$t("risk.applied-risk-decision.minimize");
      }
      return text;
    },

    openTaskDetailModal(task) {
      this.$store.dispatch("task/fetchDetail", task._id);
      this.$store.commit("task/showTaskDetailModal", true);
    },

    async removeTaskRiskRelation(task) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch("task/removeTaskRiskRelation", {
          taskId: task._id,
          riskId: this.risk._id,
        });
        this.$toast.success(this.$t("common.successful"));
        await this.save(false);
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    async linkWithTask(confirm = true) {
      if (confirm) {
        const ok = await this.confirm(this.$t("alert.approve"));
        if (!ok) {
          return;
        }
      }

      try {
        await this.$store.dispatch("task/addTaskRiskRelation", {
          taskId: this.selectedTask._id,
          riskId: this.risk._id,
        });
        await this.save(false);
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    openPolicyDetailModal(policy) {
      this.$store.commit("organizationPolicy/policyId", policy._id);
      this.fetchDetail();
    },
    editPolicy(id) {
      this.$store.commit("organizationPolicy/isEditing", true);
      this.$store.commit("organizationPolicy/policyId", id);
    },

    async deletePolicyById(id) {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationPolicy/delete`, id);
        await this.save(false);
        this.fetchDetail();
        this.$toast.success(this.$t("common.delete-successful"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    //Calculations..-->

    async handleCalculateButtonClicked() {
      this.calculateButtonClicked = true;
      await this.calculate();
    },
    async calculate() {
      const form = this.$store.getters["organizationRisk/form"];
      try {
        const { data } = await this.$store.dispatch(`organizationRisk/calculate`, form);
        this.riskDecisionProposal = data.appliedRiskDecision;

        this.form = {
          ...this.form,
          // effectValue: data.effectValue,
          appliedRiskDecision: data.appliedRiskDecision,
          appliedRiskPoint: data.appliedRiskPoint,
          appliedRiskValue: data.appliedRiskValue,
          //possibility: data.possibility,
          degree: data.degree,
          status: data.status,
          riskPointGoal: data.riskPointGoal,
        };

        if (this.form.effectValue != data.effectValue) {
          this.form.effectValue = data.effectValue;
        }
        if (this.possibility != data.possibility) {
          this.possibility = data.possibility;
        }

        if (this.riskRatingDefinition) {
          const pointGoal =
            this.form.appliedRiskPoint < this.riskRatingDefinition.low.max
              ? this.$t("risk.acceptable-point-alert", { point: this.riskRatingDefinition.low.max })
              : this.$t("risk.point-goal-alert", { point: this.riskRatingDefinition.low.max });

          this.form.riskPointGoal = pointGoal;
        }
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },

    // selections...-->

    async onTaskSearch(value, callback) {
      const response = await this.$store.dispatch(`task/fetchOrganizationTasks`, {
        options: { limit: 200 },
        query: { name: { value } },
      });

      callback(response.data?.docs ?? []);
    },

    onTaskSelect(task) {
      this.selectedTask = task;
    },

    async onPolicySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationPolicy/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, products: { value: this.currentProduct || "PLATFORM", isObject: true } },
      });

      callback(response.data?.docs ?? []);
    },

    onPolicySelect(policy) {
      this.selectedPolicy = policy;
    },

    onLegalAdminSelect(item) {
      this.approvalAssignee = {
        name: item.name,
        _id: item.accountId,
      };
    },
    async riskDefinitionSelected(item) {
      try {
        const lang = this.currentLanguage;
        this.form = {
          ...this.form,
          name: item.name[lang],
          threats: item.threats,
          weaknesses: item.weaknesses,
        };

        const data = await this.fetchRiskDetailByDefinition(item.name[this.currentLanguage]);

        if (data) {
          this.handleExistingRisk(data);
        }
      } catch (error) {}
    },
    async handleExistingRisk(data) {
      // const answer = await this.confirm("Aynı Risk tanımına sahip bir risk organizasyonda mevcut. Var olan risk ile form doldurulsun mu? ");
      // if (answer) {
      this.$store.commit("organizationRisk/risk", data);
      this.$store.commit("organizationRisk/editedEntity", data);

      if (!data.products.some((p) => p === this.currentProduct)) {
        data.products.push(this.currentProduct);
        this.form = {
          ...this.prepareFormForEdit(data, ["note", "riskPointGoal", "budgetPlan", "preventionPlanNote", "currentControls"]),
        };
        // await this.save(false);
      }
      // } else {
      //   this.form = {};
      //   this.$store.commit("organizationRisk/reset");
      // }
    },
    threatDefinitionSelected(items) {
      const lang = this.currentLanguage;

      this.form = {
        ...this.form,
        threatDefinition: items.map((i) => i.name[lang]).join(",\r"),
      };
    },
    appliedControlSelected(items) {
      const lang = this.currentLanguage;

      this.form = {
        ...this.form,
        appliedControl: items.map((i) => i.name[lang]).join(",\r"),
      };
    },

    onOrganizationSelect() {
      const dataOwner = { ...dataOwner, organization: this.currentOrganization };
      this.form = { ...this.form, dataOwner };
    },

    async onDepartmentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onDepartmentSelect(department) {
      const dataOwner = { ...dataOwner, department };
      this.form = { ...this.form, dataOwner };
    },

    async onProcessSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationProcess/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    onProcessSelect(process) {
      const dataOwner = { ...dataOwner, process };
      this.form = { ...this.form, dataOwner };
    },

    onThirdPartySelect(thirdParty) {
      this.form = { ...this.form, thirdParty };
      // this.$refs.thirdPartyFilter?.reset();
    },
    taskCreated(task) {
      this.selectedTask = task;

      this.linkWithTask(false);
      this.$refs.taskFilter.reset();
      // this.fetchDetail();
    },

    async onAppliedControlSearch(value, callback) {
      const response = await this.$store.dispatch(`riskAppliedControl/paginate`, {
        options: { limit: 200 },
        query: { name: { value }, ...this.appliedControlproductQuery },
      });
      callback(response.data?.docs ?? []);
    },
    onAppliedControlSelect(items) {
      this.form = { ...this.form, appliedControl: items };
    },

    async onThirdPartySearch(value, callback) {
      const response = await this.$store.dispatch(`organizationThirdParty/paginate`, {
        options: { limit: 200 },
        query: { name: { value } },
      });
      callback(response.data?.docs ?? []);
    },
    async removeRiskAssetGroupRelation(id) {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        await this.$store.dispatch(`organizationRiskAssetGroupRelation/delete`, id);
        await this.paginateRiskAssetGroupRelation();
        this.fetchDetail();
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    async rightPanelClosed() {
      this.$refs.thirdPartyFilter?.reset();
      this.$store.dispatch("organizationThirdParty/resetForm");
      await this.paginateRiskAssetGroupRelation();
    },
    //History
    buildHistory() {
      const loopObject = [...this.risk.history];
      //
      if (this.risk && this.risk.history.length > 1) {
        const latest = { ...this.risk, latest: true };

        latest.name = { [this.currentLanguage]: latest.name[this.currentLanguage] };

        if (!latest.dataOwner?.organization) {
          delete latest.dataOwner?.organization;
        }
        if (!latest.dataOwner?.department) {
          delete latest.dataOwner?.department;
        }
        if (!latest.dataOwner?.process) {
          delete latest.dataOwner?.process;
        }

        if (latest.updatedBy) {
          latest.updatedBy = {
            _id: latest.updatedBy._id,
            name: latest.updatedBy.name,
            ref: { _id: latest.updatedBy._id },
          };
        }
        if (latest.approval) {
          latest.approval = {
            ...latest.approval,
            reporter: {
              _id: latest.approval.reporter._id,
              name: latest.approval.reporter.name,
              ref: { _id: latest.approval.reporter._id },
            },
            assignee: {
              _id: latest.approval.assignee._id,
              name: latest.approval.assignee.name,
              ref: { _id: latest.approval.assignee._id },
            },
          };
        }
        if (latest.riskPointGoal) {
          latest.riskPointGoal = { [this.currentLanguage]: latest.riskPointGoal[this.currentLanguage] };
        }
        if (latest.appliedControl) {
          latest.appliedControl = latest.appliedControl.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.threats) {
          latest.threats = latest.threats.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.weaknesses) {
          latest.weaknesses = latest.weaknesses.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (latest.dataOwner) {
          latest.dataOwner = {
            _id: latest.dataOwner._id,
            name: latest.dataOwner.name,
          };
        }

        // loopObject.unshift(latest);
      }
      //
      this.historyItems = [];
      let prev = null;
      const arr = loopObject.reverse();

      for (const r of arr) {
        const risk = { ...r };

        risk.name = { [this.currentLanguage]: risk.name[this.currentLanguage] };

        if (!risk.dataOwner?.organization) {
          delete risk.dataOwner?.organization;
        }
        if (!risk.dataOwner?.department) {
          delete risk.dataOwner?.department;
        }
        if (!risk.dataOwner?.process) {
          delete risk.dataOwner?.process;
        }

        if (risk.riskPointGoal) {
          risk.riskPointGoal = { [this.currentLanguage]: risk.riskPointGoal[this.currentLanguage] };
        }

        if (risk.appliedControl) {
          risk.appliedControl = risk.appliedControl.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (risk.threats) {
          risk.threats = risk.threats.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }
        if (risk.weaknesses) {
          risk.weaknesses = risk.weaknesses.map((i) => ({ _id: i._id, name: i.name?.[this.currentLanguage] || i.name, ref: { _id: i._id } }));
        }

        // //-> localize field
        // if (risk.threatDefinition) {
        //   risk.threatDefinition = {
        //     [this.currentLanguage]: risk.threatDefinition[this.currentLanguage],
        //   };
        // }
        // if (risk.weaknessDefinition) {
        //   risk.weaknessDefinition = {
        //     [this.currentLanguage]: risk.weaknessDefinition[this.currentLanguage],
        //   };
        // }
        // if (risk.appliedControls) {
        //   risk.appliedControls = {
        //     [this.currentLanguage]: risk.appliedControls[this.currentLanguage],
        //   };
        // }
        if (risk.note) {
          risk.note = {
            [this.currentLanguage]: risk.note[this.currentLanguage],
          };
        }
        if (risk.preventionPlanNote) {
          risk.preventionPlanNote = {
            [this.currentLanguage]: risk.preventionPlanNote[this.currentLanguage],
          };
        }

        //<--

        if (!prev) {
          prev = { ...risk, changes: [] };
          this.historyItems.push(prev);
          continue;
        }
        const diffs = PropertyUtil.getPropsDiff(prev, risk);

        delete diffs.at;

        this.historyItems = [
          {
            ...risk,
            changes: Object.keys(diffs),
          },
          ...this.historyItems,
        ];

        prev = risk;
      }
    },
    //
    beforeUnload(e) {
      if (!this.isThereUnsavedChange) {
        return undefined;
      }

      (e || window.event).returnValue = this.reloadMessage;
      return this.reloadMessage;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organization-risk-view.scss";
</style>

<style scoped>
table {
  table-layout: fixed;
  word-wrap: break-word;
}

.diff {
  background: #ffe0e0;
}

.card-body .card-header {
  background-color: #ebedf9 !important;
}

.card-header[role="tab"],
.card-header .accordion-list {
  background-color: #e2e0ff !important;
}

.card-header[role="tab"].bg-success,
.card-header.bg-success .accordion-list {
  background-color: #eaf5ff !important;
}
.card-header[role="tab"].bg-primary,
.card-header.bg-success .accordion-list {
  background-color: #aedbf6 !important;
}
.card-header[role="tab"].bg-danger,
.card-header.bg-success .accordion-list {
  background-color: #f9dfd4 !important;
}
.custom-radius {
  border-radius: 0.625rem;
}
.custom-card {
  border-radius: 0.625rem;
  padding: 0.5rem;

  margin-bottom: 1.5rem;
}
.legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.box {
  width: 20px;
  height: 20px;
}
.bg-light-warning {
  background-color: #ffbd8a;
}
</style>

<style>
.popover.wide-popover {
  max-width: 800px !important;
  width: auto !important;
}

.popover.wide-popover .popover-body {
  max-width: auto !important;
}

.popover.wide-popover .popover-body table {
  table-layout: auto !important;
}

.popover.wide-popover .popover-body td:first-child {
  width: 140px;
  white-space: nowrap;
  vertical-align: top;
}
</style>
